import { useContext } from 'react';
import {
  AuthContext,
  type AuthContextHelpers,
  type AuthContextValue,
} from '@entities/auth';

export const useAuth = (): Omit<AuthContextValue, keyof AuthContextHelpers> => {
  const ctx = useContext(AuthContext);

  if (ctx.isAuthenticated) {
    return {
      isAuthenticated: true,
      user: ctx.user,
      isLoading: ctx.isLoading,
    };
  }

  return {
    isAuthenticated: ctx.isAuthenticated,
    user: null,
    isLoading: ctx.isLoading,
  };
};
